import Luminous, {LuminousGallery} from 'luminous-lightbox';
import Swiper, {Navigation, Autoplay} from "swiper";

Swiper.use([Navigation, Autoplay]);

export default class Property {

    constructor() {
        this.detailSlider();
        this.highlights();
        this.readmore();
        this.tabs();
        this.luminous();
    }

    highlights() {
        if (document.querySelector('.page-property #highlights')) {
            const swiper = new Swiper('.page-property #highlights .swiper-container', {
                spaceBetween: 15,
                sliderPerView: 1,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false
                },
                breakpoints: {

                    // when window width is >= 640px
                    576: {
                        slidesPerView: 2,
                        spaceBetween: 15
                    },
                    992: {
                        slidesPerView: 3,
                        spaceBetween: 15
                    },
                    1200: {
                        slidesPerView: 4,
                        spaceBetween: 15
                    },

                },
            });
        }
    }

    detailSlider() {
        if (document.querySelector('.page-property #property-slider')) {
            const swiper = new Swiper('.page-property #property-slider .swiper-container', {
                spaceBetween: 10,
                loop: true,
                navigation: {
                    nextEl: '.page-property #property-slider .swiper-button-next',
                    prevEl: '.page-property #property-slider .swiper-button-prev',
                },
            });
        }
    }

    readmore() {
        if (document.querySelector('.page-property') || document.querySelector('#project')) {
            const expandableContents = document.querySelectorAll('.expandable-content');

            expandableContents.forEach((item) => {
                item.nextElementSibling.addEventListener('click', (event) => {
                    event.preventDefault();
                    item.classList.add('active');
                    item.nextElementSibling.style.display = 'none';
                })
            })
        }
    }

    tabs() {
        if (document.querySelector('.page-property') && document.querySelector('.tabLink')) {
            const links = document.querySelectorAll('.tabLink');
            const tabs = document.querySelectorAll('#media .tab');
            links[0].classList.add('active');
            tabs[0].classList.add('active');
            links.forEach(function (el, i) {
                el.addEventListener('click', function (ev) {
                    ev.preventDefault();

                    tabs.forEach(function (tab) {
                        tab.classList.remove('active');
                    });

                    links.forEach(function (link) {
                        link.classList.remove('active');
                    });

                    let item = document.querySelector(el.getAttribute('href'));
                    this.classList.add('active');
                    item.classList.add('active');
                });
            })
        }
    }

    luminous() {
        new LuminousGallery(document.querySelectorAll('.page-property .luminous'));
    }
}
